module.exports = __webpack_public_path__ + "static/img/exhibitor_gold_en.440cc8f7.png";